
export const thousandSeparators = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}


export default thousandSeparators;




// WEBPACK FOOTER //
// ./src/helper/format.js